


















































































import { Component, Mixins } from 'vue-property-decorator'
import GlobalMixin, {ALERT_TYPE, VIEW_MODE} from '@/mixins/globalMixin'
import LoadingComponent from '@/components/LoadingComponent.vue'
import AlertBarComponent from '@/components/AlertBarComponent.vue'
import BreadcrumbsComponent from '@/components/BreadcrumbsComponent.vue'
import CustomerSelectDialogComponent from '@/components/CustomerSelectDialogComponent.vue'
import { Product } from '@/domain/Product'
import { ProductPrice } from '@/domain/ProductPrice'
import { Classification } from '@/domain/Classification'
import ProductsService from '@/service/ProductsService'
import CustomerPricesService from '@/service/CustomerPricesService'
import ClassificationsService from '@/service/ClassificationsService'
import { CustomerInfo } from '@/domain/CustomerInfo'

@Component({
  components: {
    LoadingComponent,
    AlertBarComponent,
    BreadcrumbsComponent,
    CustomerSelectDialogComponent,
  },
})
export default class MasterCustomerPriceList extends Mixins(GlobalMixin) {
  productsService = ProductsService.instance
  customerPricesService = CustomerPricesService.instance
  classificationsService = ClassificationsService.instance

  /** データテーブル ヘッダー設定 */
  headers = [
          { text: "検査項目コード", value: "pk.inspectionCode", width: "140px" },
          { text: "検査項目名", value: "inspectionName" },
          { text: "検査分類名", value: "classificationName", width: "200px" },
          { text: "標準単価", value: "standardPrice", align: "end", width: "150px" },
          { text: "顧客単価", value: "price", align: "end", width: "150px" },
  ]
  list: Product[] = []
  classifications: Classification[] = []

  /** 対象顧客 */
  customerInfo: CustomerInfo = new CustomerInfo()

  /** 検査分類 */
  classificationCode: string | undefined = undefined
  /** 検索キーワード */
  keyword = ""

  /**
   * 検索条件フィルター（フィルター機能ではなく、本来の検索相当）
   */
  get filterList() {
    if (this.classificationCode === undefined) {
      return this.list
    } else {
      return this.list.filter(x => x.classificationCode === this.classificationCode)
    }
  }

  /**
   * 初期実行
   */
  mounted() {
    this.viewMode = VIEW_MODE.VIEW

    /* 検査分類 */
    this.classificationsService.findAll()
      .then(x => this.classifications = x)

    /* 初期検索 */
    this.search()
  }

  /**
   * 検索処理
   */
  search() {
    this.viewMode = VIEW_MODE.VIEW
    if (this.customerInfo.customerPrefectureCode === "" || this.customerInfo.customerCode === "") {
      /* 顧客選択なし */
      this.list = []
      return
    }

    this.showLoading()
    this.productsService.findByCustomer(this.customerInfo.customerPrefectureCode, this.customerInfo.customerCode)
      .then(x => {
        this.viewMode = VIEW_MODE.EDIT
        this.list = x
        this.hideLoading()
      })
      .catch(error => {
        // eslint-disable-next-line
        console.log(error)
        this.alert("検索エラー", ALERT_TYPE.ERROR)
        this.hideLoading()
      })
  }

  /**
   * 登録ボタンのクリック
   */
  onSubmit() {
    this.showLoading()
    const customerPrices = this.list.filter(x => x.price !== null && x.price !== "")
      .map(x => 
        // eslint-disable-next-line
        new ProductPrice({prefectureCode: x.pk.prefectureCode, code: x.pk.code, inspectionCode: x.pk.inspectionCode, price: parseInt(x.price as string)})
      )
    this.customerPricesService.update(this.customerInfo.customerPrefectureCode, this.customerInfo.customerCode, customerPrices)
        .then(() => {
          this.alert("保存しました", ALERT_TYPE.SUCCESS)
          this.hideLoading()
          this.search()
        })
        .catch((error) => {
          // eslint-disable-next-line
          console.log(error)
          this.alert("保存に失敗しました", ALERT_TYPE.ERROR)
          this.hideLoading()
        })
  }

  /**
   * 顧客選択ダイアログの表示
   */
  openCustomerSelectDialog() {
    // TODO:修正の破棄チェックが必要
    this.customerSelectDialog = true
  }

  /**
   * 顧客選択
   */
  onCustomerSelected(event: CustomerInfo) {
    this.customerInfo = event
    this.search()
  }

}
